// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProBadge":"beb_a bhj_rh bhj_ri bhj_vf bhj_ec bhj_vc bhj_gs bhj_kf"};